import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../../Service/ApiCallMethod";
import { LIMIT_PER_PAGE } from "../../../Common/Constants";

export const getAllFormSubmissions = createAsyncThunk(
  "chat/assistant/getAllFormSubmissions",
  async ({ page, keyword, from, to, assistantId, limit }, thunkAPI) => {
    try {
      const response = await getMethod(
        `/chat/form/submission?limit=${limit ?? LIMIT_PER_PAGE}&page=${page}${
          keyword ? `&keyword=${keyword}` : ""
        }${from ? `&from=${from}` : ""}${to ? `&to=${to}` : ""}${
          assistantId ? `&assistantId=${assistantId}` : ""
        }`
      );
      const data = await response.data;
      if (response.status != 200 && response.status != 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

const initialState = {
  allFormSubmissionsData: null,
  loading: false,
  error: null,
};

export const GetAllFormSubmissionsSlice = createSlice({
  name: "forms",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllFormSubmissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllFormSubmissions.fulfilled, (state, action) => {
        state.loading = false;
        state.allFormSubmissionsData = action.payload;
        state.error = null; // Clear any previous errors
      })
      .addCase(getAllFormSubmissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetAllFormSubmissionsSlice.reducer;
